import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { H2TextBlock } from '@/uiComposites/typography/headings';
export const ResultsHeading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <H2TextBlock id="decision-tool-results-title" tabIndex={-1}>{translateInline({
        en: "Your result",
        nl: "Uw resultaat"
      })}</H2TextBlock>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};